import React, { useState } from "react"
import PropTypes from "prop-types"
import Wrapper from "components/sections/wrapper"
import RoleCard from "./card"
import "./sectionExploreRoles.scss"

const SectionExploreRoles = ({ contentTitle, roles }) => {
  const [openIndex, setOpenIndex] = useState(null)

  const handleToggle = index => {
    setOpenIndex(openIndex === index ? null : index)
  }

  const backgroundClass = contentTitle?.backgroundStyle
    ? `section-explore-roles--${contentTitle.backgroundStyle}`
    : ""

  return (
    <div className={`section-explore-roles ${backgroundClass}`}>
      {contentTitle && (
        <Wrapper {...contentTitle} className="careers-heading-wrapper" />
      )}
      <div className="section-explore-roles__roles">
        {roles.map((role, i) => (
          <RoleCard
            isOpen={openIndex === i}
            key={i}
            onToggle={() => handleToggle(i)}
            {...role}
          />
        ))}
      </div>
    </div>
  )
}

SectionExploreRoles.propTypes = {
  contentTitle: PropTypes.object,
  roles: PropTypes.arrayOf(
    PropTypes.shape({
      roleTitle: PropTypes.string.isRequired,
      content: PropTypes.shape({
        json: PropTypes.object.isRequired,
      }),
    })
  ),
}

export default SectionExploreRoles
